"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _Auth = _interopRequireDefault(require("./Auth"));

var _Accounts = _interopRequireDefault(require("./Accounts"));

var _default = (0, _redux.combineReducers)({
  auth: _Auth.default,
  accounts: _Accounts.default
});

exports.default = _default;
module.exports = exports.default;